import { stringify } from 'query-string';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { VersionsResponse } from './types.tsx';

export const MAX_RESULTS = 5;

export const getVersionsEndpointUrl = (baseUrl: string, projectKey: string): string =>
	`${baseUrl}/rest/api/2/project/${projectKey}/version`;

export const getVersionsUrlParams = (
	filter: string,
	versionStatuses: string[],
	ignore: string[],
): string =>
	stringify({
		startAt: 0,
		query: filter,
		maxResults: MAX_RESULTS + ignore.length,
		orderBy: '+NAME',
		status: versionStatuses.join(','),
	});

export const getVersionsRetrieveUrl = (
	baseUrl: string,
	projectKey: string,
	filter: string,
	versionStatuses: string[],
	ignore: string[],
): string =>
	`${getVersionsEndpointUrl(baseUrl, projectKey)}?${getVersionsUrlParams(
		filter,
		versionStatuses,
		ignore,
	)}`;

type RequestVersions = (
	arg1: string,
	arg2: string,
	arg3: string,
	arg4: string[],
	arg5: string[],
) => Promise<VersionsResponse>;

export const requestVersions: RequestVersions = async (
	baseUrl,
	projectKey,
	filter,
	versionStatuses,
	ignore,
) => fetchJson(getVersionsRetrieveUrl(baseUrl, projectKey, filter, versionStatuses, ignore));
